export const CURRENT_PAGE_DEFAULT: number = 1
export const TOTAL_PAGE_DEFAULT: number = 0

export const TRANSACTION_STEPS: Record<string, string> = {
  FIRST_STEP: 'step1',
  SECOND_STEP: 'step2',
  THIRD_STEP: 'step3',
}

export const TRANSACTION_TYPE = {
  PAYMENT: 'PAYMENT',
  PROMOTION_CANCEL: 'PROMOTION_CANCEL',
  PROMOTION: 'PROMOTION',
  COMMISSION: 'COMMISSION',
}

export const TRANSACTION_ACTION = {
  ALL: '',
  DEPOSIT: 'DEPOSIT',
  WITHDRAW: 'WITHDRAW',
  PROMOTION: 'PROMOTION',
  COMMISSION: 'COMMISSION',
}

export const TRANSACTION_STATUS = {
  FINISHED: 'FINISHED',
  CANCEL: 'CANCEL',
  DELETE: 'DELETE',
  PENDING: 'PENDING',
  CC_PENDING: 'CC_PENDING',
  PROCESSING_STATUS:
    'PROCESSING,SMART_PAY_PROCESSING,PHONE_CARD_PROCESSING,MOMO_PROCESSING,CC_PENDING,CC_PROCESSING,PENDING,APPROVED',
  PROCESSING: 'PROCESSING',
  CC_PROCESSING: 'CC_PROCESSING',
  SMART_PAY_PROCESSING: 'SMART_PAY_PROCESSING',
  PHONE_CARD_PROCESSING: 'PHONE_CARD_PROCESSING',
  MOMO_PROCESSING: 'MOMO_PROCESSING',
  APPROVED: 'APPROVED',
  DRAFT: 'DRAFT',
}

export const HISTORY_TRANSACTION_LIST_STATUS =
  'FINISHED,PENDING,CANCEL,VOID,PROCESSING,SMART_PAY_PROCESSING,PHONE_CARD_PROCESSING,MOMO_PROCESSING,APPROVED,CC_PENDING,CC_PROCESSING'

export const TRANSACTION_CRYPTO_STATUS =
  'PROCESSING,SMART_PAY_PROCESSING,APPROVED,CANCEL'

export const BANK_CODE_MAPPING: Record<string, string> = {
  vcb: 'VCB',
  acb: 'ACB',
  donga: 'DongA',
  vietinbank: 'VietinBank',
  bidv: 'BIDV',
  sacombank: 'Sacombank',
  techcombank: 'Techcombank',
}

export const DEPOSIT_METHODS: Record<string, string> = {
  ATM: 'ATM',
  IBANKING: 'Internet Banking',
  BANKING: 'Tiền mặt',
  PHONE_CARD: 'Thẻ cào',
  SMARTPAY: 'Paywin',
  MOMO: 'Ví điện tử',
  VIETTELPAY: 'Ví điện tử',
  CRYPTOPAY: 'Crypto Pay',
  CODEPAY: 'CODE PAY',
  COMMISSION: 'Hoàn trả',
  BANK_ACCOUNT: 'Internet Banking',
  EWALLET: 'Ví điện tử',
  NICEPAY: 'QRPAY',
  SENPAY: 'QR',
}

export const BETTING_STATUS_INFO = {
  LOSE: {
    statusText: 'Thua',
    statusClass: 'fail',
  },
  WIN: {
    statusText: 'Thắng',
    statusClass: 'success',
  },
  WON: {
    statusText: 'Thắng',
    statusClass: 'success',
  },
  DRAW: {
    statusText: 'Hòa',
    statusClass: 'draw',
  },
  RUNNING: {
    statusText: 'Đang chờ',
    statusClass: 'pending',
  },
  RUNING: {
    statusText: 'Đang chờ',
    statusClass: 'pending',
  },
  OPENED: {
    statusText: 'Đang chờ',
    statusClass: 'pending',
  },
  WAITING: {
    statusText: 'Đang chờ',
    statusClass: 'pending',
  },
  PENDING: {
    statusText: 'Đang chờ',
    statusClass: 'pending',
  },
  BET: {
    statusText: 'Đang chờ',
    statusClass: 'pending',
  },
  OPEN: {
    statusText: 'Đang chờ',
    statusClass: 'pending',
  },
  'HALF LOSE': {
    statusText: 'Thua một nửa',
    statusClass: 'fail',
  },
  'HALF WIN': {
    statusText: 'Thắng một nửa',
    statusClass: 'success',
  },
  'HALF WON': {
    statusText: 'Thắng một nửa',
    statusClass: 'success',
  },
  REJECT: {
    statusText: 'Bị hủy',
    statusClass: 'cancel',
  },
  REFUND: {
    statusText: 'Bị hủy',
    statusClass: 'cancel',
  },
  CANCEL: {
    statusText: 'Bị hủy',
    statusClass: 'cancel',
  },
  TIP: {
    statusText: 'Tip',
    statusClass: 'cancel',
  },
  VOID: {
    statusText: 'Bị hủy',
    statusClass: 'cancel',
  },
}
